import { gsap } from 'gsap'

export default class {

  constructor({ selector, playBtn }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelector(selector)
    this.playBtn = playBtn instanceof HTMLElement ? playBtn : document.querySelector(playBtn)
    this.isPaused = true
    this.exist = this.selector ? true : false
    //Methode
    this.exist && this.initVideo()
    this.playBtn && this.addEventListener()
  }

  addEventListener() {
    this.playBtn.addEventListener('click', () => {
      this.playVideo()
      this.initPlayBtn()
    })
  }

  initVideo() {
    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // console.log(entry.target.autoplay)
          if (entry.target.autoplay) {
            entry.target.play()
            this.isPaused = false
          }
        } else {
          entry.target.pause()
          this.isPaused = true
          this.initPlayBtn()
        }
      })
    })
    this.observer.observe(this.selector)
  }

  playVideo() {
    if (this.isPaused) {
      this.selector.play()
      this.isPaused = false
    }
    else {
      this.selector.pause()
      this.isPaused = true
    }
  }

  initPlayBtn() {
    if (this.isPaused) {
      gsap.to(this.playBtn, {
        autoAlpha: 1,
        duration: 1
      })
    } else {
      gsap.to(this.playBtn, {
        autoAlpha: 0,
        duration: 1
      })
    }
  }

}

